import React, { useEffect, useState } from 'react'
import LoginCookieAuth from '../../api/LoginCookieAuth'
import Cookies from 'js-cookie'
import SkySparkGrid from '../../api/SkySparkGrid'
import { useParams } from 'react-router-dom'
import { WeekDayChart } from '../../charts/ems'
import { Box, Typography } from '@mui/material'
import DataUnavailable from '../../data/DataUnavailable'
import InfLoader from '../../infLoad'

const DayProfile = ({ dateRange, titel, meterId }) => {
    const { siteId } = useParams();
    const [chartData, setChartData] = useState([]);
    const [chartLoading, setChartloading] = useState(true)
    const [meterName, setMeterName] = useState('')

    let formatDateRange = dateRange.replace(/\s\(.*?\)|\s-\s1day/g, '').replace(/\(|\)/g, '');

    useEffect(() => {
        LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async (authResponse) => {
            if (authResponse) {
                if(!chartLoading) setChartloading(true)
                await SkySparkGrid(`api_energyProfileWeekdays2(@${siteId},@${meterId}, ${dateRange})`).then((response) => {
                    if (response.data["rows"].length === 0 || response.data["meta"]["sampleCount"] <= 1) {
                        setChartloading(false)
                        setChartData([])
                        setMeterName('')
                      } else {
                        setChartData((<WeekDayChart dataValues={response.data["rows"]} />))
                        setMeterName(response.data["rows"][0]["pointRef"]["dis"])
                        setChartloading(false)
                    }
                })
            }
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteId, dateRange, meterId])

    return (
        <Box sx={{width:'100%', height:'92%', padding:'16px'}}>
            <Box><Typography textAlign='center' variant='h5' fontWeight='bold' sx={{color:'#141414'}}>Gemiddeld verbruik per dag</Typography></Box>
            <Box><Typography textAlign='center' variant='h6' sx={{color:'#141414'}}>{meterName}</Typography></Box>
            <Box><Typography textAlign='center' variant='h6' sx={{color:'#141414'}}>{titel} {formatDateRange.replace('..', ' T/M ')}</Typography></Box>
            {chartLoading ? (<Box sx={{width:'100%', height:'100%', display:'flex', justifyContent:'center', marginTop:'150px'}}><InfLoader/></Box>) : (chartData.length === 0 ?  <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '124px' }}><DataUnavailable/></Box> : chartData)}
        </Box>
    )
}

export default DayProfile